import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const CurriculumContext = createContext(null);

export function CurriculumProvider({ children }) {
  const { user } = useAuth();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (user && user.id) {
      api.get("/curriculum").then((r) => setData(r.data)).catch(() => {});
    }
  }, [user]);

  return <CurriculumContext.Provider value={data}>{children}</CurriculumContext.Provider>;
}

export const useCurriculum = () => useContext(CurriculumContext);
